import { HttpClient, HttpEvent, HttpEventType } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, switchMap } from 'rxjs';
import { AppConstants } from 'src/shared/AppConstants';
import { GetRequestResponse, MyProductTypes, MyRequest, MyRequestSearch, MyRequestTypes, Notifcations, RequestAckModel, RequestModel } from '../_models/request-model';
import { UtilityService } from './utility.service';
import * as moment from 'moment';
import { APIResponse } from '../_models/apiResponse';
import { REQUEST_SOURCE } from '../_enums/constant-types.enum';

@Injectable({
  providedIn: 'root'
})
export class RequestService {
  currentdate: Date = new Date();
  userNotifCountSubject$ = new BehaviorSubject<number | undefined>(0);

  public readonly userNotifCount$ = this.userNotifCountSubject$.pipe(
    switchMap(() => {
      const criteria: { EnvironmentID: string | undefined; LoggedInUserId: string; } = {
        EnvironmentID: AppConstants.EnvironmentId,
        LoggedInUserId: this.utility.getAppUserInfo().PK_UserId ?? '',
      };

      return this.http.post<number>(AppConstants.PortalApiBaseUrl + '/api/Request/PortalNotificationsCount', criteria);
    })
  );

  constructor(private http: HttpClient, private utility: UtilityService) { }

  saveRequest(requestModel: RequestModel): Observable<APIResponse> {
    requestModel.EnvironmentID = AppConstants.EnvironmentId;
    if (!requestModel["FK_REPORTER_TYPE_ID"]) {
      requestModel["FK_REPORTER_TYPE_ID"] = AppConstants.ReporterTypeId;
    }
    requestModel.FK_USER_ID = this.utility.getAppUserInfo().PK_UserId ?? "";
    requestModel.ReporterTypeName = AppConstants.ReporterTypeName ?? '';
    return this.http.post<APIResponse>(AppConstants.PortalApiBaseUrl + '/api/Request/SaveRequest', requestModel);
  }

  GetMyRequests(criteria: MyRequestSearch): Observable<Array<MyRequest>> {
    criteria.PortalID = this.utility.getPortalID();
    criteria.EnvironmentID = AppConstants.EnvironmentId;
    criteria.UserID = this.utility.getAppUserInfo().PK_UserId;
    criteria.UITIMEZONE = moment(this.currentdate).format('Z');
    return this.http.post<Array<MyRequest>>(AppConstants.PortalApiBaseUrl + '/api/Request/GetMyRequests', criteria);
  }

  GetMyRequestTypes(): Observable<Array<MyRequestTypes>> {
    const criteria = {
      UserID: this.utility.getAppUserInfo().PK_UserId,
      PortalID: this.utility.getPortalID(),
      EnvironmentID: AppConstants.EnvironmentId,
    };
    return this.http.post<Array<MyRequestTypes>>(AppConstants.PortalApiBaseUrl + '/api/Request/GetRequestTypes', criteria);
  }

  GetMyProductTypes(): Observable<Array<MyProductTypes>> {
    const criteria = {
      UserID: this.utility.getAppUserInfo().PK_UserId,
      PortalID: this.utility.getPortalID(),
      EnvironmentID: AppConstants.EnvironmentId,
    };
    return this.http.post<Array<MyProductTypes>>(AppConstants.PortalApiBaseUrl + '/api/Request/GetProductTypes', criteria);
  }

  GetRequest(requestID: string): Observable<RequestModel> {
    const criteria = {
      UserID: this.utility.getAppUserInfo().PK_UserId,
      PortalID: this.utility.getPortalID(),
      EnvironmentID: AppConstants.EnvironmentId,
      PK_REQUEST_ID: requestID,
      REQUEST_SOURCE: REQUEST_SOURCE.PORTALS,
    }
    return this.http.post<RequestModel>(AppConstants.PortalApiBaseUrl + '/api/Request/GetRequest', criteria);
  }

  GetRequestAckDetails(requestID: string): Observable<RequestAckModel> {
    const criteria = {
      UserID: this.utility.getAppUserInfo().PK_UserId,
      PortalID: this.utility.getPortalID(),
      EnvironmentID: AppConstants.EnvironmentId,
      PK_REQUEST_ID: requestID,
      REQUEST_SOURCE: 'Portal',
    }
    return this.http.post<RequestAckModel>(AppConstants.PortalApiBaseUrl + '/api/Request/GetRequestAckDetails', criteria);
  }

  GetRequestResponseDetails(requestId: string, responseId: string): Observable<RequestAckModel> {
    const response: GetRequestResponse = {
      UserId: this.utility.getAppUserInfo().PK_UserId ?? "",
      EnvironmentId: AppConstants.EnvironmentId ?? "",
      RequestId: requestId,
      ResponseId: responseId,
      REQUEST_SOURCE: 'Portal',
    }
    return this.http.post<RequestAckModel>(AppConstants.PortalApiBaseUrl + '/api/Request/GetResponseDetails', response);
  }

  DownloadRequestResponseDetails(requestId: string, responseId: string, hasAttachments: boolean, type: string): Observable<any> {
    const DownloadResponse = {
      EnvironmentId: AppConstants.EnvironmentId ?? "",
      UserId: this.utility.getAppUserInfo().PK_UserId ?? "",
      ResponseId: responseId,
      RequestId: requestId,
      DownloadType: type,
      HasAttachments: hasAttachments
    }
    return this.http.post(AppConstants.PortalApiBaseUrl + '/api/Request/DownloadResponseDetails', DownloadResponse, { observe: 'response', responseType: 'blob' });
  }

  deleteRequest(requestID: string): Observable<APIResponse> {
    const criteria = {
      UserID: this.utility.getAppUserInfo().PK_UserId,
      PortalID: this.utility.getPortalID(),
      EnvironmentID: AppConstants.EnvironmentId,
      PK_REQUEST_ID: requestID
    }
    return this.http.post<APIResponse>(AppConstants.PortalApiBaseUrl + '/api/Request/DeleteRequest', criteria);
  }

  getNotificationsData(): Observable<Array<Notifcations>> {
    return this.http.get<Array<Notifcations>>(AppConstants.PortalApiBaseUrl + '/api/Request/PortalNotificationsList/' + AppConstants.EnvironmentId);
  }

  hasResponses(): Observable<boolean> {
    return this.http.get<boolean>(AppConstants.PortalApiBaseUrl + '/api/Request/PortalHasResponses/' + AppConstants.EnvironmentId);
  }

  downloadBlob(data: HttpEvent<Blob>, fileName: string) {
    switch (data.type) {
      case HttpEventType.Response:
        const downloadedFile = new Blob([data.body as BlobPart], { type: data.body?.type });
        const a = document.createElement('a');
        a.setAttribute('style', 'display:none;');
        document.body.appendChild(a);
        a.download = fileName;
        a.href = URL.createObjectURL(downloadedFile);
        a.target = '_blank';
        a.click();
        document.body.removeChild(a);
        break;
    }
  }

}


